import styled from 'styled-components';

import {Link} from '../../ui-kit/Link';

export const CustomLink = styled(Link)`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-size: 12px;
    line-height: 12px;
    font-weight: 500;
    text-decoration: none;
`;

export const Wrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    width: auto;
    margin-left: 10px;
    margin-bottom: 16px;
`;
